// extracted by mini-css-extract-plugin
export default {"content":"DadosSimulacao_content__7l8lv","description":"DadosSimulacao_description__Cvo0X"};